import React, { useState, useEffect } from "react";
// import Dropdown from "react-bootstrap/Dropdown";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Tab,
  Nav,
  Dropdown,
} from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTablePagination,
} from "../../../Common/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { customerList, deleteUser, rowSorting } from "../../../store/actions";
import Filters from "./Filters";
import { toast } from "react-toastify";
import moment from "moment";

const Name = (value) => {
  return (
    value &&
    JSON.parse(value.amtaxsettlement_data)?.FirstName +
      " " +
      JSON.parse(value.amtaxsettlement_data)?.LastName
  );
};

const Email = (value) => {
  return value && JSON.parse(value.amtaxsettlement_data)?.Email;
};

const Mobile = (value) => {
  return value && JSON.parse(value.amtaxsettlement_data)?.CellPhone;
};

const TableDate = (value) => {
  return value && moment(value?.created_at).format("DD-MM-YYYY");
};

const Profile = (val) => {
  return val && JSON.parse(val.amtaxsettlement_data)?.profile_image;
};

const columnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "profile_image",
    align: false,
    disablePadding: true,
    label: "Profile Image",
    title: "Profile Image",
    order: 1,
    type: "image",
    // action: Profile,
  },
  {
    id: "Name",
    align: false,
    disablePadding: true,
    label: "Name",
    title: "Name",
    order: 1,
    type: "action",
    action: Name,
  },
  {
    id: "Email",
    align: true,
    disablePadding: false,
    label: "Email",
    title: "Email",
    order: 1,
    type: "action",
    action: Email,
  },
  {
    id: "mobile_number",
    numeric: false,
    disablePadding: false,
    label: "Mobile Number",
    title: "Mobile",
    order: 1,
    type: "action",
    action: Mobile,
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    title: "Created At",
    order: 1,
    type: "action",
    action: TableDate,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    title: "status",
    type: "tag",
    order: 1,
  },
  {
    id: "action",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Action",
  },
  {
    id: "action1",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Doc Review",
  },
];

const CustomerIndex = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const [filterBy, setFilterBy] = useState("email");
  const [dragUsers, setDragUsers] = useState("");
  const [state, setState] = useState({
    orderBy: "sort_index",
    order: "asc",
    page: 0,
    limit: 10,
    searchBy: "",
    search: "",
    tab: "all",
    archive: "0",
    admin_id: "",
  });

  const [Delete, setDelete] = useState({
    open: false,
    dumpId: "",
  });

  const [Archive, setArchive] = useState({
    open: false,
    dumpId: "",
  });
  const adminId = localStorage.getItem("id");
  const userData = useSelector((s) => s?.Customers?.user?.data);
  const totalCount = useSelector((s) => s.Customers?.user?.total_count);
  const loading = useSelector((s) => s.Customers?.loading);

  useEffect(() => {
    if (adminId) {
      setState((pre) => ({ ...pre, admin_id: adminId }));
    }
  }, [adminId]);
  useEffect(() => {
    if (adminId && state.admin_id) {
      dispatch(customerList(state));
    }
  }, [state, adminId]);

  useEffect(() => {
    if (userData) {
      setDragUsers(userData);
    }
  }, [userData]);

  const limitUser = (localStorage && localStorage.getItem("userLimit")) || 10;

  useEffect(() => {
    setState((pre) => ({
      ...pre,
      limit: JSON.parse(limitUser),
    }));
  }, [limitUser]);

  const handleLimitChange = (num) => {
    setState((pre) => ({
      ...pre,
      limit: num,
    }));
    localStorage.setItem("userLimit", num);
  };

  const handleStatus = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setFilterBy(value);
  };

  const resetFilter = () => {
    setState((pre) => ({
      ...pre,
      search: "",
    }));
    setFilter("");
  };

  const handleChangePage = (event, page) => {
    setState((pre) => ({
      ...pre,
      page: page,
    }));
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setFilter(value);
  };

  const filterdata = (e) => {
    e.preventDefault();
    let body = {
      ...state,
      search: filter,
      searchBy: filterBy,
    };
    dispatch(customerList(body));
  };

  const DeletePopup = (state, id = "") => {
    setDelete((pre) => ({
      ...pre,
      open: state,
      dumpId: id,
    }));
  };

  const ArchivePopup = (state, id = "") => {
    setArchive((pre) => ({
      ...pre,
      open: state,
      dumpId: id,
    }));
  };

  const handleDelete = () => {
    const callBack = (response) => {
      if (response.status == 200) {
        toast.success("User Deleted Successfully");
        setDelete(false);
        dispatch(customerList(state));
      } else {
        toast.error("");
      }
    };
    dispatch(deleteUser({ id: JSON.stringify(Delete.dumpId) }, callBack));
  };

  const handleTabChange = (value) => {
    if (value == "archive") {
      setState((pre) => ({ ...pre, tab: value, archive: "1" }));
    } else {
      setState((pre) => ({ ...pre, tab: value, archive: "0" }));
    }
  };

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(dragUsers);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setDragUsers(tempData);

    let body = {
      id: e?.draggableId,
      current_index: JSON.stringify(e?.source?.index + 1),
      destination_index: JSON.stringify(e?.destination?.index + 1),
      action_on: "users",
    };
    dispatch(rowSorting(body));
  };

  return (
    <>
      <Modal
        show={Archive.open}
        onHide={() => {
          setArchive(false);
        }}
        className="deleteAdd-pop delete-pop"
        centered
      >
        <Modal.Body>
          <div className="text-center py-3">
            <div className="icn my-3">
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256    C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216    c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z"
                  fill="#f8c886"
                ></path>
                <path
                  d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877    C276,137.831,267.046,128.877,256,128.877z"
                  fill="#f8c886"
                ></path>
                <circle cx="256" cy="349.16" r="27" fill="#f8c886"></circle>{" "}
              </svg>
            </div>
            <h2 className="pop-head m-0 pb-2">Do you want to Archive?</h2>
            <div className="btn-wrap my-2 d-flex align-items-center justify-content-center mt-3">
              <div className="pe-2 w-50">
                <Button
                  className="btn-2 w-100 d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setArchive(false);
                  }}
                >
                  No Cancel!
                </Button>
              </div>
              <div className="pe-2 w-50">
                <Button
                  // onClick={handleArchive}
                  className=" w-100 d-flex align-items-center justify-content-center"
                >
                  Yes, Archive it
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={Delete.open}
        onHide={() => {
          setDelete(false);
        }}
        className="deleteAdd-pop delete-pop"
        centered
      >
        <Modal.Body>
          <div className="text-center py-3">
            <div className="icn my-3">
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256    C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216    c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z"
                  fill="#f8c886"
                ></path>
                <path
                  d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877    C276,137.831,267.046,128.877,256,128.877z"
                  fill="#f8c886"
                ></path>
                <circle cx="256" cy="349.16" r="27" fill="#f8c886"></circle>{" "}
              </svg>
            </div>
            <h2 className="pop-head m-0 pb-2">Are you Sure?</h2>
            <div className="btn-wrap my-2 d-flex align-items-center justify-content-center mt-3">
              <div className="pe-2 w-50">
                <Button
                  className="btn-2 w-100 d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setDelete(false);
                  }}
                >
                  No Cancel!
                </Button>
              </div>
              <div className="pe-2 w-50">
                <Button
                  onClick={handleDelete}
                  className=" w-100 d-flex align-items-center justify-content-center"
                >
                  Yes, Delete it
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">Accounts</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Filters
                status={state.status}
                columns={state.columns}
                filter={filter}
                handleStatus={handleStatus}
                handleSearchChange={handleSearchChange}
                filterdata={filterdata}
                resetFilter={resetFilter}
                filterBy={filterBy}
              />
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey={state.tab}
              >
                <Nav variant="pills" className="bg-white mb-3 commonTabs">
                  <Nav.Item>
                    <Nav.Link
                      className="bg-transparent border-0 py-3 position-relative"
                      eventKey="all"
                      onClick={() => handleTabChange("all")}
                    >
                      All
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className="bg-transparent border-0 py-3 position-relative"
                      eventKey="today"
                      onClick={() => handleTabChange("today")}
                    >
                      Today
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className="bg-transparent border-0 py-3 position-relative"
                      eventKey="thisWeek"
                      onClick={() => handleTabChange("week")}
                    >
                      This Week
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className="bg-transparent border-0 py-3 position-relative"
                      eventKey="thisMonth"
                      onClick={() => handleTabChange("month")}
                    >
                      This Month
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className="bg-transparent border-0 py-3 position-relative"
                      eventKey="thisYear"
                      onClick={() => handleTabChange("year")}
                    >
                      This Year
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className="bg-transparent border-0 py-3 position-relative"
                      eventKey="archive"
                      onClick={() => handleTabChange("archive")}
                    >
                      Archived Clients
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <div className="bg-white px-4 py-3 card-box">
                  <div className="table-responsive py-3">
                    <DragDropContext onDragEnd={handleDragEnd}>
                      <DataTable className="">
                        <DataTableHead
                          columns={columnData}
                          orderBy={state.orderBy}
                          // sort={handleRequestSort}
                        />
                        <Droppable droppableId="droppable-1">
                          {(provider) => (
                            <DataTableBody
                              loading={loading}
                              column={columnData}
                              data={dragUsers}
                              page={state.page}
                              rowsPerPage={state.limit}
                              innerRef={provider.innerRef}
                              dropProp={provider.droppableProps}
                              docBtn={[
                                {
                                  label: "Total Doc",
                                  icon: "",
                                  link: "/customers/profile",
                                },
                                {
                                  label: "Pending",
                                  icon: "",
                                  link: "/customers/profile",
                                },
                                {
                                  label: "Submitted",
                                  icon: "",
                                  link: "/customers/profile",
                                },
                                {
                                  label: "Accepted",
                                  icon: "",
                                  link: "/customers/profile",
                                },
                                ,
                              ]}
                              actionBtn={[
                                {
                                  label: "View",
                                  icon: "",
                                  link: "/customers/profile",
                                },
                                {
                                  label: "Edit",
                                  icon: "",
                                  link: "/customers/edit",
                                },
                                {
                                  label: "Mail",
                                  icon: "",
                                  link: "/customers/mail",
                                },
                                {
                                  label: "Text",
                                  icon: "",
                                  link: "/customers/sms",
                                },
                                {
                                  label: "Password",
                                  icon: "",
                                  link: "/customers/reset-password",
                                },
                                {
                                  label: "Assign",
                                  icon: "",
                                  link: "/customers/assign",
                                },
                                {
                                  label: "Financial",
                                  icon: "",
                                  link: "/finance-form/edit",
                                },
                                {
                                  label: "Notes",
                                  icon: "",
                                  link: "/customers/notes",
                                },
                                {
                                  label: "Delete",
                                  icon: "",
                                  action: DeletePopup,
                                },
                              ]}
                            />
                          )}
                        </Droppable>
                      </DataTable>
                    </DragDropContext>
                    {dragUsers?.length > 0 && (
                      <div className="custom-pagination d-flex align-items-center w-100 justify-content-end">
                        <div className="main-pagination-drop d-flex gap-2 align-items-center">
                          <h6 className="row-per-page-heading m-0">
                            Rows per page:
                          </h6>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                            >
                              {state.limit}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => handleLimitChange(10)}
                              >
                                10
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleLimitChange(25)}
                                // onClick={() =>
                                //   setState((pre) => ({ ...pre, limit: 25 }))
                                // }
                              >
                                25
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleLimitChange(50)}
                              >
                                50
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleLimitChange(100)}
                              >
                                100
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <DataTablePagination
                          count={totalCount}
                          rowsPerPage={state.limit}
                          page={state.page}
                          onPageChange={handleChangePage}
                          rowsPerPageOptions={[]}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CustomerIndex;
